<!-- Activity Graph Section -->
<div id="wait" *ngIf="isLoading == 1">
  <mat-spinner></mat-spinner>
</div>

<div class="chart-container" style="width: 90%;" *ngIf="showChart1">
  <highcharts-chart #chart1 [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag"
    [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
    style="width: 100%; height: 100%; display: block;"></highcharts-chart>
</div>
<div class="chart-container" style="width: 90%;" *ngIf="showChart2">
  <highcharts-chart #chart2 [Highcharts]="Highcharts" [options]="chartOptions1" [(update)]="updateFlag"
    [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
    style="width: 100%; height: 100%; display: block;"></highcharts-chart>
</div>

<!-- Strain Graph -->
<div class="chart-container" style="width: 90%; position: relative; min-height: 300px;" *ngIf="showChart3">
  <highcharts-chart #chart3 [Highcharts]="Highcharts" [options]="strainChartOptions" [(update)]="updateFlag"
    [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
    style="width: 100%; height: 100%; display: block;"></highcharts-chart>
  <div *ngIf="noStrainDataFound"
    style="position: absolute; top: 50%; left: 0; width: 100%; text-align: center; transform: translateY(-50%); pointer-events: none;">
    <h6 style="color: gray;">No Record found for selected date range</h6>
  </div>
</div>

<br />

<div class="activity-section">
  <h2 class="section-heading">Activity Trend</h2>

  <div *ngFor="let date of getGroupedDates()" class="date-group">
    <br />
    <p class="date-heading">{{ date | date:'MMMM dd, y' }}</p>
    <div class="activity-container">
      <div class="activity-card" *ngFor="let activity of groupedActivities[date]">
        <div class="icon">
          <img src="/assets/img/activity.png" alt="Activity">
        </div>
        <div class="details">
          <p><strong>{{ activity.calsBurned }}</strong> Kcal</p>
          <p>{{ activity.type }}</p>
          <p *ngIf="activity.startTime && activity.endTime">{{ activity.startTime | date:'shortTime' }} - {{ activity.endTime | date:'shortTime' }}</p>
        </div>
        <div class="details">
          <p><strong>{{ activity.mints }}</strong> mins</p>
          <p>Total time duration</p>
        </div>
      </div>
    </div>
  </div>
</div>

<br />

<!-- Original Activity Section -->
<div class="col-md-12 flex">
  <div class="col-md-9 float">
    <div class="col-md-7 mainSleep float">

      <div class="col-md-12 ml-3">
        <highcharts-chart [Highcharts]="Highcharts" [options]="coptions"
          style="max-height: 100%; display: block;"></highcharts-chart>
      </div>
    </div>
    <div class="col-md-5 float ">
      <div class="col-md-12 float sleepSub ml-1">
        <p><img class="img" src="/assets/img/heat.png" /></p>
        <p class="totalBurn">Total Calories Burned</p>
        <p class="totalCount">{{activity && activity.calsBurntStatus?activity.totalCalsBurnt+ ' cal':'---'}}</p>
        <p><button class="btn btnClass" [style.background-color]="calsBtnColor">{{calsStatus}}</button></p>
      </div>
    </div>
  </div>
  <!-- <div class="col-md-4 float" style="margin-top:-70px">
        <div class="noteSection">Notes Section</div>
        <app-notes></app-notes>
    </div> -->

</div>